var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import { summaries } from "../../helper/util";
import PlanOrderForUpperSupService from '../../api/PlanOrderForUpperSupService';
import CommonService from '../../api/CommonService';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import HeaderItemText from "@/components/HeaderItemText.vue";
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 260;
        _this.formData = {};
        _this.data = [];
        _this.rowId = '';
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    Detail.prototype.created = function () {
        this.planOrderForUpperSupService = PlanOrderForUpperSupService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getDetail();
        this.getGoodsTypeList();
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.getDetail();
    };
    Detail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.planOrderForUpperSupService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            (data.details || []).forEach(function (item) {
                _this.calcGoodRow(item);
            });
            _this.formData = data;
            _this.data = data.details;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.calcGoodRow = function (row) {
        if (row.order_detail_money) {
            var noTaxMoney = 0;
            noTaxMoney = row.order_detail_money - row.order_detail_tax_money;
            noTaxMoney = new Number(noTaxMoney).toFixedNoZero(4);
            row.order_detail_no_tax_money = noTaxMoney;
        }
        else {
            row.order_detail_no_tax_money = 0;
        }
    };
    Detail.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_tax_rate", "order_detail_amount", "order_detail_uprice", "order_detail_money"];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        sums[6] = '';
        sums[7] = '';
        sums[8] = '';
        return sums;
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                HeaderItemText: HeaderItemText,
                HeaderItemText: HeaderItemText
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
